import { isReadOnly } from '@syncfusion/ej2/spreadsheet';
import { ExcelDataService } from '../../DataService/ExcelDataService';
import { ImportDataService } from '../../DataService/ImportDataService';
import { CommonHelper } from '../../Helpers/CommonHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { PdfViewer, Toolbar, Magnification, Navigation, LinkAnnotation} from '@syncfusion/ej2-pdfviewer';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { StringHelper } from '../../Helpers/StringHelper';
import { Select2Helper } from '../../Helpers/Select2Helper';
import { UpdateImportDataHeaderManager } from './UpdateImportDataHeaderManager';


export class ImportValidateDocHeaderManager {

    constructor(private containerElement: JQuery) { }

    private importDocHeaderId;
    private createEnquiryInfoModal : ModalHelper; 
    private emailRequestAttachmentsModalHelper : ModalHelper;

    private editImportDataHeaderButton : JQuery<HTMLElement>;
    private editImportDataHeaderModalHelper : ModalHelper;    

    private updateImportDataHeaderManager : UpdateImportDataHeaderManager;

    public initialize() {
        var self = this;

        PdfViewer.Inject(Toolbar, Magnification, Navigation, LinkAnnotation);

        self.importDocHeaderId = self.containerElement.data('import-doc-header-id');

        this.createEnquiryInfoModal = new ModalHelper();
        this.createEnquiryInfoModal.createModal("create-enquiry-info-popup", true);

        this.editImportDataHeaderModalHelper = new ModalHelper();
        this.editImportDataHeaderModalHelper.createModal("update-import-data-doc-header-popup", true);        

        this.emailRequestAttachmentsModalHelper = new ModalHelper();
        this.emailRequestAttachmentsModalHelper.createModal("email-request-attachments-popup", true);

        self.bindEvents();
    }


    private bindEvents() {
        var self = this;

        var createEnquiryButton = $('button[form="import-validated-import-doc-header-form"]');
        var createEnquiryForm = $('#import-validated-import-doc-header-form');
        var spinner = self.containerElement.find('#pdf-spinner');

        var deleteButton = self.containerElement.find('#delete-import-doc-header-button');
        

        createEnquiryForm.find('input'), function(){
            $(this).bind('keypress keydown keyup', function(e){
               if(e.keyCode == 13) { e.preventDefault(); }
            });
        };

        createEnquiryButton.off('click').on('click', () => {
            createEnquiryButton.prop('disabled', true);

            ImportDataService.canCreateEnquiryFromImportDocHeader(self.importDocHeaderId, (result) => {
                if(result) {
                    createEnquiryForm.trigger('submit');
                }
                else {
                    self.createEnquiryInfoModal.load(`?handler=CantCreateEnquiryInfo`);
                    createEnquiryButton.prop('disabled', false);
                    //load error
                }
            })
        })

        var pdfViewerContainer = self.containerElement.find('#pdf-viewer');

        let pdfViewer: PdfViewer = new PdfViewer({
            documentPath: pdfViewerContainer.data('path'),
            enableNavigationToolbar: false,
            enableStickyNotesAnnotation: false,
            enableThumbnail: false,
            enableBookmark: false,
            enableHyperlink: false,
            enableAnnotationToolbar: false,
            enableDownload: false,
            toolbarSettings: {
                showTooltip: false,
                toolbarItems: ['PageNavigationTool', 'MagnificationTool']
            },
            height: '99%',
            created: () => {
                spinner.remove();
            },
            documentLoad: (args) => {
                var formFields = pdfViewer.retrieveFormFields();
                formFields.map((formField) => {
                    var isReadOnly : any = { isReadOnly: true };
                    pdfViewer.formDesignerModule.updateFormField(formField, isReadOnly);
                });
            }
        });

        pdfViewer.appendTo('#pdf-viewer');

        deleteButton.off('click').on('click', () => {
            deleteButton.prop('disabled', true);

            new ConfirmModal().initialize('Remove enquiry to validate', 'Are you sure you want to remove this enquiry?</br>This action cannot be reverted.', () => {
                ImportDataService.deleteImportDocHeader(self.importDocHeaderId, (result) => {
                    if(result) {
                        location.href = '/Company/Import/Validate';
                    }
                    else {
                        location.reload();
                    }
                })
            }, () => {
                deleteButton.prop('disabled', false);
            }, 'Confirm', 'Cancel')
        })

        var emailRequestAttachmentsButton = self.containerElement.find('#email-request-attachments-button');
        emailRequestAttachmentsButton.off('click').on('click', () => {
            self.emailRequestAttachmentsModalHelper.load(`?importDocHeaderId=${self.importDocHeaderId}&handler=EmailRequestAttachments`, undefined, () => {

            }, 
            undefined);
        }); 

        self.editImportDataHeaderButton = self.containerElement.find('#edit-import-data-header-button');
        self.editImportDataHeaderButton.off('click').on('click', () => {
            self.editImportDataHeaderModalHelper.load(`?importDocHeaderId=${self.importDocHeaderId}&handler=UpdateImportDataDocHeader`, undefined, () => {
                if(self.updateImportDataHeaderManager == undefined) {
                    self.updateImportDataHeaderManager = new UpdateImportDataHeaderManager(self.editImportDataHeaderModalHelper.getModalContainer());
                }

                self.updateImportDataHeaderManager.initialize();
            }, 
            undefined);
        });  
        
        (<any>window).initializeImportValidateDocHeader = () => {
            if(self.editImportDataHeaderModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                //self.workbookGrid.refresh();
            }
            else {
                self.updateImportDataHeaderManager.initialize();
            }
        }

    }


}